export { extractProperty } from "./extractProperty"
export { generateSchema } from "./FormSchema"
export { getAlternateMetadataFromPathname } from "./getAlternateMeta"
export { getBreadCrumbs, type BreadCrumbs } from "./getBreadCrumbs"
export { getAccordionItems, type AccordionItem } from "./getContactContent"
export { getLocalizedUrl } from "./getLocalizedUrl"
export { getNonUmbracoUrl } from "./getNonUmbracoUrl"
export {
  cleanHtmlForMeta,
  decodeHtmlEntities,
  stripHtmlTags,
} from "./htmlUtils"
export { cultureMap, getDirection, type Culture } from "./intl"
export { extractMetaTags } from "./metaTags"
export { extractSearchResults, type Result } from "./searchResults"
export { transformProperties } from "./simplifyData"
export { transformHistoryData, type HistoryData } from "./tansformHistoryData"
export {
  transformArticlesData,
  type ArticlesData,
} from "./transformArticlesData"

export {
  baseIframeUrl,
  customerId,
  widgetLocaleConfig,
} from "./moovitConstants"
export {
  transformData,
  transformMany,
  type TrafficUpdate,
} from "./transformUpdate"

export {
  Link,
  getPathname,
  redirect,
  routing,
  usePathname,
  useRouter,
} from "./routing"

export { replaceRichTextLinks } from "./replaceRichTextLinks"
